import React from "react";

class TheaterVideo extends React.Component {
  render() {
    return <div className="theater-video">{this.props.children}</div>;
  }
}

export default TheaterVideo;
